<template>
    <v-app>
        <v-snackbar
            v-model="snackbar"
        >
            {{ msg }}
            <v-btn
                dark
                text
                @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
        <v-content fluid>
            <HeaderSimple/>
            <ComponentLogin v-on:data="saveData" />
        </v-content>
    </v-app>
</template>

<script>
import HeaderSimple from '../../components/HeaderSimple';
import ComponentLogin from '../../components/ComponentLogin';

export default {
  data() {
    return {
      snackbar: false,
      msg: '',
    };
  },
  components: {
    HeaderSimple,
    ComponentLogin,
  },

  methods: {
    saveData(data) {
      if (data.token) {
        localStorage.setItem('user-token', data.token);
        localStorage.setItem('user-id', data.id);
        localStorage.setItem('user-category', data.category);
        localStorage.setItem('user-data', JSON.stringify(data.user));
        this.$router.replace('/psicologo');
      } else if (data.response.data.non_field_errors) {
        this.snackbar = true;
        this.msg = data.response.data.non_field_errors[0];
      } else if (data.response.data.detail) {
        this.snackbar = true;
        this.msg = data.response.data.detail;
      }
    },
  },
};

</script>
